export default __webpack_public_path__ + "static/media/web_dev.59f937f7.png";